"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
PricelistController.$inject = ['$scope', '_pricelist'];
function PricelistController($scope, _pricelist) {
    $scope.downloading = false;
    $scope.download = function () {
        if ($scope.downloading) {
            return;
        }
        $scope.downloading = true;
        _pricelist.downloadXls()
            .then(function (response) {
            var blob = new Blob([response], {
                type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            });
            var url = window.URL.createObjectURL(blob);
            var a = document.createElement('a');
            a.href = url;
            a.download = $scope.buildFileName();
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            window.URL.revokeObjectURL(url);
            $scope.downloading = false;
        }, function (error) {
            $scope.downloading = false;
            if (error.data.error.details && error.data.error.details.locale) {
                notify.error(error.data.error.details.locale.rs);
            }
            else {
                notify.error(error.data.error.message);
            }
            console.log(error);
        });
    };
    $scope.buildFileName = function () {
        var now = new Date();
        function pad(n) {
            return n.toString().padStart(2, '0');
        }
        var formattedDate = pad(now.getDate()) + '-' +
            pad(now.getMonth() + 1) + '-' +
            now.getFullYear() + ' ' +
            pad(now.getHours()) + '-' +
            pad(now.getMinutes()) + '-' +
            pad(now.getSeconds());
        return 'Spektar cenovnik ' + formattedDate + '.xlsx';
    };
}
exports.PricelistController = PricelistController;



//////////////////
// WEBPACK FOOTER
// ./scripts/apps/pricelists/controllers/PricelistController.js
// module id = 406
// module chunks = 0